<template>
    <DataTable :value="data" :paginator="!pdf" :rows="50" rowHover removableSort stripedRows scrollable scrollDirection="both"
               :rowsPerPageOptions="[10, 25, 50]" class="m-4" scrollHeight="90vh" @row-select="onRowSelect"
               :selectionMode="drillInAvailable ? 'single' : ''"
               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
               :currentPageReportTemplate="$t('AppWorkAnalyzerTable.Exibindo {first} até {last} de {totalRecords} registros')">
        <Column :field="pivot" :header="$t(`AppWorkAnalyzerTable.${pivot} (s)`)" headerClass="headerClass" frozen
                :sortable="!pdf" :footer="$t('AppWorkAnalyzerTable.Totais/Médias')" :sortField="`${pivot}.label`"
                :styles="setStyle(190, 'space-between')">
            <template #body="slotProps">
                {{ pivot === 'operations' ? parseDates(slotProps.data[pivot].label) : slotProps.data[pivot].label }}
                <Button v-if="(pivot === 'fields' || pivot === 'operations') && !pdf" style="font-size: 0.75rem"
                        icon="pi pi-external-link" class="p-button-rounded p-button-sm"
                        @click.stop="goToFieldAnalysis(slotProps.data)"/>
            </template>
        </Column>
        <Column field="area" :header="$t('AppWorkAnalyzerTable.Área')" :footer="total.area" headerClass="headerClass"
                :sortable="!pdf" :styles="setStyle(130, 'center')"/>
        <Column v-if="view.code === 'performance'" field="productivity" headerClass="headerClass" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.Produtividade')" :footer="total.productivity"
                :styles="setStyle(160, 'center')"/>
        <Column field="time" :header="$t('AppWorkAnalyzerMowingTable.Tempo de roçagem')"
                :footer="total.time" headerClass="headerClass" :sortable="!pdf" :styles="setStyle(160, 'center')"/>
        <Column v-if="view.code === 'performance'" field="fuel" headerClass="headerClass" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.Combustível total')" :footer="total.fuel"
                :styles="setStyle(180, 'center')"/>
        <Column v-if="view.code === 'performance'" field="fuel_rate" headerClass="headerClass" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.Combustível por hora')" :footer="total.fuel_rate"
                :styles="setStyle(180, 'center')"/>
        <Column v-if="view.code === 'performance'" field="fuel_productivity" headerClass="headerClass" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.Combustível por área')" :footer="total.fuel_productivity"
                :styles="setStyle(180, 'center')"/>
        <Column field="speed" :header="$t('AppWorkAnalyzerTable.Velocidade')" :footer="total.speed"
                headerClass="headerClass" :sortable="!pdf" :styles="setStyle(150, 'center')"/>
        <Column v-if="!pdf" field="end_date" :header="$t('AppWorkAnalyzerMowingTable.Última roçagem')" :sortable="!pdf"
                :footer="total.end_date" headerClass="headerClass" :styles="setStyle(160, 'center')">
            <template #body="slotProps">
                <span>{{ dateFormat(slotProps.data.end_date) }}</span>
            </template>
        </Column>
        <Column v-if="!pdf && pivot !== 'fields' && !drillInString.includes('FIELDS')" field="fields" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.fields (s)')" sortField="fields.label"
                :footer="total.fields.total" headerClass="headerClass" :styles="setStyle(160, 'center')">
            <template #body="slotProps">
                <div v-tooltip.bottom="slotProps.data.fields.tooltip" @click.stop="setPivot('fields', slotProps.data)">
                    {{ slotProps.data.fields.label }}
                </div>
            </template>
        </Column>
        <Column v-if="!pdf && pivot !== 'vehicles' && !drillInString.includes('VEHICLES')" field="vehicles" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.vehicles (s)')" sortField="vehicles.label"
                :footer="total.vehicles.total" headerClass="headerClass" :styles="setStyle(160, 'center')">
            <template #body="slotProps">
                <div v-tooltip.bottom="slotProps.data.vehicles.tooltip" @click.stop="setPivot('vehicles', slotProps.data)">
                    {{ slotProps.data.vehicles.label }}
                </div>
            </template>
        </Column>
        <Column v-if="!pdf && pivot !== 'operations' && !drillInString.includes('OPERATIONS')" field="operations" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.operations (s)')" sortField="operations.label"
                :footer="total.operations.total" headerClass="headerClass" :styles="setStyle(190, 'center')">
            <template #body="slotProps">
                <div v-tooltip.bottom="slotProps.data.operations.tooltip" @click.stop="setPivot('operations', slotProps.data)">
                    {{ slotProps.data.operations.tooltip.disabled ? parseDates(slotProps.data.operations.label) : slotProps.data.operations.label }}
                </div>
            </template>
        </Column>
        <Column v-if="!pdf && pivot !== 'varieties' && !drillInString.includes('VARIETIES')" field="varieties" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.varieties (s)')" sortField="varieties.label"
                :footer="total.varieties.total" headerClass="headerClass" :styles="setStyle(160, 'center')">
            <template #body="slotProps">
                <div v-tooltip.bottom="slotProps.data.varieties.tooltip" @click.stop="setPivot('varieties', slotProps.data)">
                    {{ slotProps.data.varieties.label }}
                </div>
            </template>
        </Column>
        <Column v-if="!pdf && pivot !== 'operators' && !drillInString.includes('OPERATORS')" field="operators" :sortable="!pdf"
                :header="$t('AppWorkAnalyzerTable.operators (s)')" sortField="operators.label"
                :footer="total.operators.total" headerClass="headerClass" :styles="setStyle(160, 'center')">
            <template #body="slotProps">
                <div v-tooltip.bottom="slotProps.data.operators.tooltip" @click.stop="setPivot('operators', slotProps.data)">
                    {{ slotProps.data.operators.label }}
                </div>
            </template>
        </Column>
    </DataTable>
</template>

<script>

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tooltip from "primevue/tooltip";
import dateFormat from "@/mixins/DateMixin";
import Button from "primevue/button";

export default {
    mixins: [dateFormat],
    data() {
        return {
            DRILL_IN_AVAILABLE: 5
        }
    },
    methods: {
        parseDates(label) {
            let start_end = label.split(' - ');
            let start = this.dateFormat(new Date(start_end[0] * 1000) / 1000, 'GMT');
            let end = this.dateFormat(new Date(start_end[1] * 1000) / 1000, 'GMT');
            return `${start} - ${end}`;
        },
        onRowSelect(event) {
            let drillIn = {
                key: this.pivot,
                value: event.data[this.pivot].grouped_items[0].id
            }
            this.$emit('drillIn', drillIn)
        },
        setStyle(width, align) {
            return {
                'flex-grow': 1,
                'flex-basis': `${width}px`,
                'display': 'flex',
                'justify-content': align,
                'padding-left': align === 'center' ? '0' : '1rem !important',
                'padding-right': align === 'center' ? '0 !important' : '1rem !important'
            }
        },
        goToFieldAnalysis(data) {
            let fieldId = data['fields'].id
            let operationId = this.pivot === 'fields' ? null : data['operations'].id

            this.$emit('goToFieldAnalysis', fieldId, operationId)
        },
        setPivot(col, data) {
            this.onRowSelect({data: data});
            this.$emit('setPivot', col);
        }
    },
    props: {
        data: {
            type: Array
        },
        total: {
            type: Object
        },
        pivot: {
            type: String
        },
        drillInString: {
            type: String
        },
        pdf: {
            type: Boolean
        }
    },
    directives: {
        'tooltip': Tooltip
    },
    computed: {
        drillInAvailable: function () {
            let currentDrillIn = this.drillInString.split(':');
            return currentDrillIn.length < this.DRILL_IN_AVAILABLE;
        }
    },
    components: {Button, DataTable, Column, Tooltip}
}
</script>

<style scoped>
</style>
